import { Injectable } from '@angular/core';
import { LocalNotifications, LocalNotificationSchema, LocalNotificationsPlugin } from '@capacitor/local-notifications';


@Injectable({
  providedIn: 'root'
})
export class LocalNotificationsService {

  private lnp:LocalNotificationsPlugin=LocalNotifications;
  constructor() {

  }

  /**
   * Generates Local Notification with Capacitor
   * @param message : string
   * @param title string
   */
  public async generateLN(message:string, title:string){
    let premitted:boolean=false;
    const checkperm=await this.lnp.checkPermissions();
    switch(checkperm.display){
      default:
        const lnperm=await this.lnp.requestPermissions();
        if(lnperm.display==='granted'){
          premitted=true;
        }
      break;
      case 'granted':
        premitted=true;
      break;
    }
    if(premitted===true){
        const lN:LocalNotificationSchema={
          title:title,
          body:message,
          id:140,
          //summaryText:translation+" "+formattedDate,
          largeBody:message,
          largeIcon:"ic_stat_c_logo.png"
          /*,
          Daten könnten der LN übergeben werden
          extra: {
            data:this.smokingProtocol
          }*/
        }
        const schedres=await this.lnp.schedule({
          notifications:[lN]
        });
        console.log(schedres)
      }
      /*
      Man könnte die übergebenen Daten auch wieder "on tap" abfangen
      LocalNotifications.addListener('localNotificationActionPerformed',(notification: LocalNotificationActionPerformed)=>{
        this.smokingProtocol=notification.notification.extra.data;
        console.log(this.smokingProtocol);
      });*/

  }

  /**
   * Deletes all Capacitor LocalNotifications
   * @returns  
   */
  public async deleteLN_All(){
    const pending = {
      notifications: [
        {
          id: 140, // must be a string
        },
      ],
    };
    return LocalNotifications.cancel(pending);
  }
}
